import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchMemberNotification,
  updateMemberNotification,
} from '../myprofile/MyProfileActions';
import notificationsConfig from './NotificationsConfig';
import NotificationsSection from './NotificationsSection';
// eslint-disable-next-line import/no-named-as-default
import NotificationsItem from './NotificationsItem';

function NotificationsPage() {
  const dispatch = useDispatch();
  const [config, setConfig] = useState();

  useEffect(() => {
    dispatch(fetchMemberNotification()).then((res) => {
      setConfig(res);
    });
  }, [dispatch]);

  useEffect(() => {
    if (!config) return;
    dispatch(updateMemberNotification(config));
  }, [config]);

  const onChangeConfig = (enabled, type, isPushNotification = true) => {
    setConfig((prev) => {
      if (!prev) return prev;

      const key = isPushNotification ? 'pushNotifications' : 'emailNotifications';

      return {
        ...prev,
        [key]: (prev[key] ?? []).map((it) =>
          it.notificationType === type ? { ...it, enabled } : it,
        ),
      };
    });
  };

  return notificationsConfig.map((notificationsConfig) => (
    <NotificationsSection title={notificationsConfig.section}>
      {notificationsConfig.notifications.map((notification) => (
        <NotificationsItem {...notification} config={config} onChange={onChangeConfig} />
      ))}
    </NotificationsSection>
  ));
}

export default NotificationsPage;
